var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 15.2C13.8627 15.2 14.4 14.6627 14.4 14C14.4 13.3372 13.8627 12.8 13.2 12.8C12.5373 12.8 12 13.3372 12 14C12 14.6627 12.5373 15.2 13.2 15.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 15.2C6.66279 15.2 7.20005 14.6627 7.20005 14C7.20005 13.3372 6.66279 12.8 6.00005 12.8C5.33731 12.8 4.80005 13.3372 4.80005 14C4.80005 14.6627 5.33731 15.2 6.00005 15.2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.8C0 0.358172 0.358172 0 0.8 0H3.41818C3.79817 0 4.12573 0.267297 4.20193 0.639564L4.72604 3.19992H14.8C15.039 3.19992 15.2655 3.30678 15.4175 3.49126C15.5694 3.67573 15.631 3.91848 15.5852 4.15307L14.5367 9.52866C14.4386 10.0117 14.1706 10.4418 13.7844 10.7457C13.4008 11.0476 12.9241 11.207 12.437 11.1998H6.48808C6.00097 11.207 5.52428 11.0476 5.14069 10.7457C4.75465 10.4419 4.48669 10.012 4.38848 9.52915C4.38844 9.52899 4.38851 9.52932 4.38848 9.52915L3.296 4.19226C3.29094 4.17176 3.28667 4.15096 3.28323 4.12988L2.76536 1.6H0.8C0.358172 1.6 0 1.24183 0 0.8ZM5.05357 4.79992L5.95635 9.21013C5.97793 9.31637 6.0378 9.41566 6.13028 9.48845C6.22314 9.56154 6.34212 9.60224 6.46647 9.59991L6.48145 9.59976H12.4436L12.4586 9.59991C12.583 9.60224 12.7019 9.56154 12.7948 9.48845C12.8866 9.41618 12.9463 9.3178 12.9683 9.21243L13.8289 4.79992H5.05357Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.35c28973637a6d55eb893cfc66d94600.svg";
export { ForwardRef as ReactComponent };